module.exports = __webpack_public_path__ + "assets/img/tx30g_2.c2e45702.jpg";